import { post } from '@/lib/request/index';
import { feed, common } from '../apiConstants';
// 首页聚合接口
export function feedIndexV2(param) {
  return post(feed.FEED_INDEX_V2, { param });
}

// 首页天降红包
export function popDialog(param) {
  return post(common.POP_DIALOG, { param });
}

// 首页搜索饭店或者商品
export function feedSearch(param) {
  return post(feed.FEED_SEARCH, { param });
}
